import React from 'react';

import './index.css';


const getText = () => (
  <div styleName="textContainer">
    <div styleName="bulleted">
      &#8226;&emsp;The decision to purchase this security rests solely with me
    </div>
    <br />
    <div styleName="bulleted">
      &#8226;&emsp;I have the appropriate investor status and/or authority
      to make this investment
    </div>
    <br />
    <div styleName="bulleted">
      &#8226;&emsp;I agree to permit My IPO to provide to
      the issuer my name, address, and other personal information on an ongoing
      basis to the extent I continue to hold this security
    </div>
    <br />
    <div styleName="bulleted">
      &#8226;&emsp;My IPO and the issuer are relying on the truth and
      accuracy of the information provided and representations made with respect
      to submission of this investment request
    </div>
    <br />
    <div styleName="bulleted">
      &#8226;&emsp;No person representing the issuer or My IPO or purporting
      to represent the issuer or My IPO has made any oral representation
      that is inconsistent with the information contained in the offering documents
    </div>
    <br />
    <div styleName="bulleted">
      &#8226;&emsp;My IPO has made no representations to me as to the
      suitability of this investment, unless otherwise noted on this site
    </div>
    <br />
    <div styleName="bulleted">
      &#8226;&emsp;If I am using this site as an authorized representative of an
      investor, I represent that I am capable of evaluating the investment risks
      associated with investing in unregistered and/or unlisted securities
      independently and I am exercising my independent judgment in concluding that
      this investment is appropriate for my client
    </div>
    <br />
    <div styleName="bulleted">
      &#8226;&emsp;If I am not an accredited investor and if the security I&#39;m
      subscribing to here is an unlisted security that is issued under Regulation A
      Tier 2, then I certify that my subscription represents less than 10% of the
      greater of my annual income or net worth (less than 10% of the greater of annual
      revenue or net assets at fiscal year end if the investor is a corporate entity)
    </div>
    <br />
    <div styleName="bulleted">
      &#8226;&emsp;Take the time to read and carefully understand the terms of
      the proposed investment.
    </div>
    <br />
    <div styleName="bulleted">
      &#8226;&emsp;Investments in unregistered and/or unlisted securities generally
      have a higher level of risk than national exchange traded securities. Only
      limited information may be available about these securities and their issuers.
    </div>
    <br />
    <div styleName="bulleted">
      &#8226;&emsp;Unregistered and/or unlisted securities generally may be illiquid.
      Investors may have no ability to sell or transfer the securities, and even
      where a sale or transfer is permitted, there may be no buyers.
    </div>
    <br />
    <div styleName="bulleted">
      &#8226;&emsp;You must not have a contract, agreement or arrangement, formal
      or informal, with any person to sell, transfer or pledge any interest or
      rights in the securities, and have no present plans to enter into any such
      obligation.
    </div>
    <br />
    <div styleName="bulleted">
      &#8226;&emsp;The issuer is ultimately responsible for deciding who is
      permitted to purchase securities in the offering and the amount of the
      investment.  Even if an investor meets all qualification requirements,
      the issuer may reduce requested investment amounts or reject investment
      requests completely.
    </div>
    <br />
    <div styleName="bulleted">
      &#8226;&emsp;The securities purchased can be retained in electronic form at
      the transfer agent for the Issuer or can be delivered to you
      in physical form. Some brokerage firms may not hold these securities
      or may charge fees to deposit these securities.
    </div>
    <br />
    <div styleName="bulleted">
      &#8226;&emsp;This Offering requires you to wire funds directly from an
      existing bank account to the Offering Escrow Account. You will
      receive an email with instructions on how to complete your
      purchase. For this offering type, If you have funds in your My IPO
      account they cannot be transferred to the Offering Escrow
      Account.
    </div>
    <br />
    <div styleName="bulleted">
      &#8226;&emsp;You are responsible for choosing this investment and you
      should not assume that anyone (including My IPO) has
      investigated, analyzed or otherwise evaluated the investment or
      determined that it is appropriate for you. The fact that an
      investment opportunity is made available through our web site is
      not an endorsement of the investment by anyone.
    </div>
    <br />
    <div>
      MY IPO, LLC IS THE ONLINE OFFERING PLATFORM DIVISION OF CAMBRIA CAPITAL, LLC. Cambria Capital, LLC dba My IPO is a registered Broker/Dealer and member FINRA/SIPC. ALL SECURITIES ARE ONLY OFFERED BY CAMBRIA CAPITAL, LLC DOING BUSINESS AS MY IPO. This is neither an offer to sell nor a solicitation of an offer to buy securities.
    </div>
  </div>
);

export default getText;



// WEBPACK FOOTER //
// ./src/components/ExternalInvest/DisclaimerViews/TermsAndConditionsText.js